module.exports = __webpack_public_path__ + "img/layers.1772a35f.svg";